import ClassChooseConfirm from "./ClassChooseConfirm";

export default ClassChooseConfirm;
export { ClassChooseConfirm };
